import { useTranslation } from 'react-i18next';

import { StyledButton } from 'components/shared';

import styles from './FormStepsFooter.module.css';

type FormStepsFooterProps = {
   onBack: () => void;
   onSave?: () => void;
   backDisabled: boolean;
   lastStep?: boolean;
   disabledNextButton?: boolean;
};

const FormStepsFooter = ({
   onBack,
   backDisabled,
   lastStep,
   disabledNextButton,
}: FormStepsFooterProps) => {
   const { t } = useTranslation();
   return (
      <div className={styles.footerBtnsContainer}>
         {!backDisabled && (
            <StyledButton
               type="button"
               variant="outlined-primary"
               text={t('reportDamage.stepFooter.back')}
               onClick={onBack}
            />
         )}
         <StyledButton
            type="submit"
            variant="filled-primary"
            text={lastStep ? t('clientsPage.addClientButton') : t('common.next')}
            disabled={disabledNextButton}
         />
      </div>
   );
};
export default FormStepsFooter;
